<template>
  <div class="my-layout-box">
    <list-view
      :getList="getList"
      :isTabsShow="isTabsShow"
      :isButtonShow="isButtonShow"
      :buttonList="buttonList"
      @onSeeDetail="onSeeDetail"
      :placeholderTitle="placeholderTitle"
      :listMap="listMap"
    >
    </list-view>
  </div>
</template>

<script>
import listView from "~/components/List/ListView.vue";
import { itemsData } from "./config";
import { getRemittance } from "~/api/finance";
export default {
  name: "RemittanceView",
  components: {
    listView
  },
  data() {
    return {
      isTabsShow: false,
      isButtonShow: true,
      listMap: itemsData,
      buttonList: [{ title: "查看详情" }],
      placeholderTitle: "请输入付汇单号"
    };
  },

  methods: {
    async getList(pagination, searchData) {
      let sendData = {
        page: pagination.page,
        limit: pagination.size
      };
      sendData.value = searchData.value;
      const list = await getRemittance(sendData);
      const data = {
        List: list.Items,
        Total: list.Total
      };
      return data;
    },
    onSeeDetail(items) {
      const { Id } = items;
      this.$router.push({
        name: "remittanceDetail",
        query: {
          id: Id
        }
      });
    }
  }
};
</script>

<style lang="less" scope></style>
